import { useEffect, useRef } from 'react';

// Keep the two panes inside the visible viewport, including the phone keyboard.
export default function useWorkspaceViewport() {
  const ref = useRef(null);
  useEffect(() => {
    let frame;
    const viewport = window.visualViewport;
    const measure = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!ref.current) return;
        const top = Math.max(0,ref.current.getBoundingClientRect().top - (viewport?.offsetTop || 0));
        ref.current.style.height = Math.max(0,(viewport?.height || window.innerHeight) - top) + 'px';
      });
    };
    window.scrollTo(0, 0);
    measure(); window.addEventListener('resize',measure);
    if (viewport) { viewport.addEventListener('resize',measure); viewport.addEventListener('scroll',measure); }
    return () => { cancelAnimationFrame(frame); window.removeEventListener('resize',measure); if (viewport) { viewport.removeEventListener('resize',measure); viewport.removeEventListener('scroll',measure); } };
  },[]);
  return ref;
}
